<template>
    <div>
      <van-sticky :offset-top="0">
        <van-nav-bar
        title="编辑信息"
        left-text="返回"
        right-text="按钮"
        left-arrow
        @click-left="onClickLeft"
        @click-right="onClickRight"/>
        <van-search v-model="value" shape="round" background="#4fc08d" placeholder="请输入搜索关键词"  show-action>
            <template #label>
                <div @click="openDialog">{{type}}</div>
            </template>
            <template #action >
                <div @click="onSearch" >搜索</div>
            </template>
        </van-search>
      </van-sticky>
        <van-pull-refresh v-model="refreshing" style ="background-color:aliceblue;" @refresh="onRefresh">
            <van-list
                  v-model="loading"
                  :finished="finished"
                  finished-text="没有更多了"
                  @load="onLoad">
              <van-cell-group inset v-for=" item  in questionList" :key = item.index  style="margin-top : 10px" >
                  <van-cell title="题目" is-link>
                    <template #title>
                      <van-tag type="danger">第{{  item.index + 1}}题</van-tag>
                      <van-tag type="danger"> {{item.code  }}</van-tag>
                      <van-tag type="danger">{{item.type  }}</van-tag>
                      <van-tag type="danger">{{ item.model }}</van-tag>
                    </template>
                    <template #label>
                      <span class="custom-title">{{ item.content }}</span>
                    </template>
                 </van-cell>
                 <van-cell v-if = " item.urls.length != 0">
                    <template>
                    <van-grid :border="false" :gutter="1" square :column-num="3">
                    <van-grid-item v-for="itm  in item.urls" :key=itm.index>
                        <van-image :src="itm.url" style="border: solid 1px black; "/>
                        <van-tag type="danger">{{ itm.index }}</van-tag>
                    </van-grid-item>
                  </van-grid>
                  </template>
                 </van-cell> 
              <van-cell v-for = "(ite) in item.options" :key = ite.index >
                <template #title>
                  <van-tag type="danger">{{ ite.index }}</van-tag>
                  <span>{{ ite.option }} </span>
                </template>
              </van-cell> 
              <van-cell>
                <template #title>
                  <van-tag type="danger">答案</van-tag>
                  <span>{{ item.ansver }}</span>
                </template>
              </van-cell> 
              <van-cell >
                <template #title>
                  <van-tag type="danger">解析</van-tag>
                  <span>{{ item.anyn }}</span>
                </template>
              </van-cell> 
            </van-cell-group>
          </van-list>
        </van-pull-refresh>
         <van-popup v-model="showPicker"  round position="bottom">
          <van-picker
            show-toolbar
            :columns="columns"
            title="查询条件"
            @cancel="showPicker = false"
            @confirm="onConfirm"/>
        </van-popup>

      
       <!-- <van-cell style="background-color:aliceblue">
          <template #title>
            <van-pagination style="position: fixed; bottom:0 " v-model="currentPage" :total-items="24" :items-per-page="5" />
          </template>
        </van-cell>-->
    </div>
  </template>
  <script>
    import { Search } from 'vant';
    import  SERVICE_URL from '@/api/url'
    export default {
      name : 'questionList',
      data () {
        
        return {
            type : "姓名",
            value:"123123",
            list: [],
            loading: false,
            finished: false,
            refreshing: false,
            showPicker: false,
            columns: ['杭州', '宁波', '温州', '绍兴', '湖州', '嘉兴', '金华', '衢州'],
            loginForm: {
            userName: '',
            password: ''  ,
            value: '',
            },
            questionList : [],
            quetions:[{aId : "A" , content:"顺序导致的问题"},{aId : "B" , content:"顺序导致的问题2"}],
            rules: {
            userName: [
              { required: true, message: '请输入用户名', trigger: 'blur' }
            ],
            password: [
              { required: true, message: '请输入密码', trigger: 'blur' }
            ]
          },
          showLogin: false
        }
      },
      mounted () {
       
        this.showLogin = true;
      },
      methods: {
        onConfirm(value){

          this.showPicker = false;
          this.type = value;
        },
        openDialog(){

          this.showPicker = true;
        },
        onSearch(){

          

        },
        onLoad() {
            // 异步更新数据
            // setTimeout 仅做示例，真实场景中一般为 ajax 请求
            setTimeout(() => {
              if (this.refreshing) {
                  this.list = [];
                  this.refreshing = false;
                }
                for (let i = 0; i < 10; i++) {
                    let item = {
                      id : i,
                      userName:"雷布斯" + i,
                      gender : "男",
                      email : "cxf@lrc.cn",
                      workNo : "2505",
                      deptName : "信息技术部",
                      phone : "18734148493"
                    }
                    this.list.push(item);
                }

                // 加载状态结束
                this.loading = false;
                
                // 数据全部加载完成
                if (this.list.length >= 40) {
                    this.finished = true;
                }
            }, 1000);
            for(let i = 0 ; i< 100 ; i++ ) {
              let item = {
                  type : "多选",
                  index : i,
                  model : "信息安全",
                  code : "1000" + i,
                  content : "为了观察到margin-bottom下补白、下边距效果样式，我们设置2个DIV盒子，两个盒子css宽为200px,css高为100px;1px实线边框；设置其第一个margin-bottom下距离为10px,。第一个盒子css命名为divcss5-margin",
                  ansver : "ABC",
                  anyn :"解析:为了观察到margin-bottom下补白、下边距效果样式，我们设置2个DIV盒子，两个盒子css宽为200px,css高为100px;1px实线边框；设置其第一个margin-bottom下距离为10px,。第一个盒子css命名为divcss5-margin"
              }
              let urlSize = i % 7;
              let urls = [];
              let options = [];
              for (let j = 0 ; j< urlSize; j++ ){
                let urlinfo ={

                  url :"https://img01.yzcdn.cn/vant/apple-3.jpg",
                  index : j
                }
                urls.push(urlinfo);
               
              }
              if (urlSize == 0){

                urlSize = 1;
              } ;
      
              for (let j = 0 ; j< urlSize; j++ ){
                
                let optionsInfo = {
                  option  :"option是" + i,
                  index : j
                }
                options.push(optionsInfo);
              }
              item["urls"]  =  urls;
              item["options"] = options;
              this.questionList.push(item);
            }
            console.log(this.questionList);
        },
        async submitForm (loginInfo) {

          // this 是Vue 
          let _this = this
          let data =JSON.parse(JSON.stringify(this.loginForm))
          this.$refs[loginInfo].validate(async (valid) => {
            if (valid) {
                  _this.$store.commit(TOKEN_ID, "11111111111")
                  let URL  =  SERVICE_URL + '/user/login'; 
                    // _this.$store.commit(STORE_USER_INFO, _this.loginForm.userName)
                    // _this.$store.commit('tokenId', response.data.data.tokenId)
                    _this.$router.push('manage')
                    _this.$message.success(response.data.message)
              //    axios.post(URL, data).then((response) => {
              //     if (response.data.code === 0) {
              //       // 这里进行存储信息
              //       // 跳转页
              //       _this.$store.commit(STORE_USER_INFO, _this.loginForm.userName)
              //       _this.$store.commit('tokenId', response.data.data.tokenId)
              //       _this.$router.push('manage')
              //       _this.$message.success(response.data.message)
              //     } else {
              //       _this.$message({
              //         showClose: true,
              //         message: response.data.message,
              //         type: 'error',
              //         duration: 0
              //       })
              //     }
              //   }).catch(function (err) {
              //       _this.$message({
              //         showClose: true,
              //         message: err.message,
              //         type: 'error',
              //         duration: 0
              //       })
              // });
            }
          })
        },
        onSearch (){


        },
        onRefresh() {
            // 清空列表数据
            this.finished = false;

            // 重新加载数据
            // 将 loading 设置为 true，表示处于加载状态
            this.loading = true;
            this.onLoad();
        },
      }
    }
  </script>
  
  <style lang="less" scoped>
      .title-class {
          width: 10%;

      }
  </style>
  


// WEBPACK FOOTER //
// src/mini_pages/question/questionList.vue